"use client";

import { ArrowLeftIcon } from "@heroicons/react/24/outline";

import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";

interface Props {
  hideLabel?: boolean;
  alwaysVisible?: boolean;
  fallbackRoute: string;
  ignoreHistory?: boolean;
}

export const BackButton = ({
  hideLabel,
  alwaysVisible,
  fallbackRoute,
  ignoreHistory,
}: Props) => {
  const router = useRouter();
  const [hasHistory, setHasHistory] = useState(false);

  const back = () => {
    if (ignoreHistory) return router.push(fallbackRoute);
    if (hasHistory) return router.back();
    return router.push(fallbackRoute);
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      setHasHistory(window.history.length > 1);
    }
  }, []);

  return hasHistory || alwaysVisible ? (
    <div>
      <Button
        variant="ghost"
        className="flex items-center justify-center gap-2"
        onClick={back}
      >
        <ArrowLeftIcon width={18} height={18} />
        {!hideLabel ? "Voltar" : null}
      </Button>
    </div>
  ) : null;
};
